import { render, staticRenderFns } from "./foor-style-6.vue?vue&type=template&id=61b76a5c&scoped=true"
import script from "./foor-style-6.vue?vue&type=script&lang=js"
export * from "./foor-style-6.vue?vue&type=script&lang=js"
import style0 from "./foor-style-6.vue?vue&type=style&index=0&id=61b76a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b76a5c",
  null
  
)

export default component.exports